import { render, staticRenderFns } from "./templateProduct.vue?vue&type=template&id=79167a51&scoped=true&"
import script from "./templateProduct.vue?vue&type=script&lang=js&"
export * from "./templateProduct.vue?vue&type=script&lang=js&"
import style0 from "./templateProduct.vue?vue&type=style&index=0&id=79167a51&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79167a51",
  null
  
)

export default component.exports